/**
 * **WHICH SITE THIS BUILD IS SERVING RIGHT NOW** (CONTENT_ENGINE §8.1).
 *
 * One build, one bucket, one distribution, two addresses: `clubs.kiddiekredit.com` is the club portal and
 * `admin.kiddiekredit.com` is Kiddie Kredit's own content admin. The host decides which route tree registers,
 * so **club staff never meet a staff-only route and the admin site has no club screens at all** — not hidden
 * ones, not guarded ones, absent ones.
 *
 * **It reads the sub-domain rather than an env var**, and that is deliberate: a build-time flag would mean two
 * builds, two bundles and two invalidations, and the first deploy that published the wrong one to the wrong
 * alias would be invisible until somebody tried a URL. One artefact that decides at runtime cannot be
 * mismatched with the address serving it.
 *
 * `admin.` as a PREFIX covers both the real host and `admin.localhost:5173`, which browsers resolve to the
 * machine without any hosts-file entry — so the local split is the same rule as production rather than a
 * second one that can drift.
 */
const ADMIN_PREFIX = 'admin.';

/** The club portal's public address, for the one link the admin site offers a person who is not staff. */
export const CLUBS_URL = 'https://clubs.kiddiekredit.com';
/** Where `clubs.kiddiekredit.com/admin/quest` sends a bookmark after the move. */
export const ADMIN_URL = 'https://admin.kiddiekredit.com';

/**
 * True on the content-admin address. Takes the hostname so a test can ask about either site without touching
 * `window`; defaults to the live one.
 */
export function isAdminHost(hostname: string = globalThis.location?.hostname ?? ''): boolean {
  return hostname.toLowerCase().startsWith(ADMIN_PREFIX);
}
